import React from 'react'
import WardsModal from '../../WardDetails/WardsModal'

const Wards = () => {
  return (
    <div>

      <WardsModal/>

    </div>
  )
}

export default Wards
